// extracted by mini-css-extract-plugin
export default {"container":"style_container__cUaM8","backgroundImg":"style_backgroundImg__pioBG","titleBox":"style_titleBox__SzkV+"};